<template>
  <div class="UpdatePhoneBox">
    <van-popup v-model="showPopup" position="bottom">
      <div class="popoverContent">
        <div class="title">
          手机号变更
          <img src="@/assets/images/drawerClose.png" alt="" class="drawerClose" @click="showPopup = false">
        </div>
        <input type="text" class="input" :value="this.desenName(publicPage.userName)" disabled>
        <input type="text" class="input" :value="publicPage.identity" disabled>

        <input type="text" class="input" @input="onPhoneChange" placeholder="请输入新手机号" :value="phoneTransfrom(newPhone)" maxlength="13">
        <div class="codeBox">
          <input type="text" class="input" v-model="code" ref="codeInput" maxlength="6" placeholder="请输入验证码">
          <div class="getCode" @click="getCode">{{count ? `${count}s后重试` : '获取验证码'}} </div>
        </div>

        <div class="buttonGroup">
          <div class="submit" @click="onDetermine">确认变更</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast, Dialog } from 'vant';
import { mapState } from 'vuex';
export default {
  name: 'UpdatePhone',
  props: {
    value: {
      type: Boolean,
    },
  },
  components: {
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  data() {
    return {
      invoiceDetailList: [],
      oneYearAmount: '',
      updateTime: '',
      showPopup: false,
      count: 0,
      code: '',
      timer: null,
      newPhone: ''
    };
  },
  mounted() {
  },
  watch: {
    value: {
      handler(newValue) {

      },
      immediate: true,
    },
  },
  methods: {
    onPhoneChange(e) {
      this.newPhone = e.target.value.replace(/\s*/g, "")
    },
    // 手机号码展示转换
    phoneTransfrom(value) {
      if (value.length > 10) {
        value = value.slice(0, 3) + ' ' + value.slice(3, 7) + ' ' + value.slice(7, 11)
      } else if (value.length > 6) {
        value = value.slice(0, 3) + ' ' + value.slice(3, 7) + ' ' + value.slice(7, value.length)
      } else if (value.length > 2) {
        value = value.slice(0, 3) + ' ' + value.slice(3, value.length)
      }
      return value
    },
    desenName(str) {
      let newStr = "";
      if (str) {
        if (str.length == 2) {
          newStr = str.substring(0, 1) + "*";
        } else if (str.length == 3) {
          newStr = str.substring(0, 1) + "*" + str.substring(2, 3);
        } else if (str.length > 3) {
          newStr = str.substring(0, 1) + "*" + "*" + str.substring(3, str.length); //截取第一个和大于第4个字符
        }
        return newStr;
      } else {
        console.log("姓名为空");
        return newStr;
      }
    },
    onClose() {
      this.$emit('input', false);
    },
    getCode() {
      let reg = /^(1)\d{10}$/
      if (!reg.test(this.newPhone)) {
        Toast('请填写正确的手机号码');
        return false
      }
      if (this.count !== 0) {
        return
      }
      this.$refs.codeInput.focus()
      this.$api.PublicPage.getSms({
        phone: this.newPhone,
        type: '10',
      }).then(res => {
        if (!res.success) {
          return Toast(res.returnMessage)
        }
        Toast('发送成功，请查收短信')
        this.count = 60
        this.timer = setInterval(() => {
          console.log(this.count, '=cumm')
          if (this.count > 0) {
            this.count--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000)
      })
    },
    onDetermine() {
      let reg = /^(1)\d{10}$/
      if (!reg.test(this.newPhone)) {
        Toast('请填写正确的手机号码');
        return
      }
      if (!this.code) {
        return Toast('请输入验证码')
      }
      this.$api.PublicPage.modifyPhone({ captcha: this.code, newPhone: this.newPhone, skip: 1, type: '10' }).then(res => {
        if (!res.success) {
          return Toast(res.returnMessage)
        }
        this.showPopup = false
        this.rightNext()
      })

    },
    rightNext() {
      this.$api.PublicPage.logout()
        .then((res) => {
          if (res.success) {
            localStorage.removeItem('name');
            localStorage.removeItem('loanPeoplePhone');
            localStorage.setItem('redirect', '/supermarket/v2/');
            Dialog.alert({
              title: '变更成功',
              message: '手机号变更成功，请重新登录。',
              confirmButtonText: '重新登录'
            }).then(() => {
              this.$router.push('/supermarket/v2/login');
            });
          } else {
            this.$toast.fail(res.returnMessage);
          }
        })
        .catch(() => { });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>
<style lang="scss" scoped>
.popoverContent {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 500;
  .codeBox {
    display: flex;
    align-items: center;
    .input {
      flex: 1;
    }
    .getCode {
      margin-left: 10px;
      width: 80px;
    }
  }
  .buttonGroup {
    display: flex;
    background: #fff;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    margin-bottom: 30px;
    margin-top: 10px;
    .submit {
      background: #ff6538;
      border-radius: 4px;
      flex: 1;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      line-height: 44px;
      height: 44px;
    }
  }
  .input {
    margin-top: 10px;
    height: 35px;
    border: none;
    background: #fff;
    margin-top: 10px;
    color: #1c2438;
  }
  .input::placeholder {
    font-size: 14px;
    font-weight: normal;
  }
}
.title {
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px 8px 0 0;
  color: #1c2438;
  font-size: 16px;
  .drawerClose {
    width: 20px;
    height: 20px;
  }
}

.outModal {
  width: 50%;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .title {
    font-size: 16px;
    align-self: baseline;
    font-weight: 500;
  }
  .content {
    font-size: 14px;
    padding: 10px 0;
  }
  .outBtn {
    width: 100px;
    background: var(--var-primary-color);
    color: #fff;
    margin-top: 10px;
    font-size: 14px;
  }
  .successIcon {
    width: 50px;
    height: 50px;
    margin-top: 10px;
  }
}
>>> .van-popup--bottom {
  z-index: 10000 !important;
  border-radius: 8px 8px 0 0;
}
</style>

<style>
.van-dialog__message--has-title {
  padding-top: 26px;
}
/* .van-overlay {
  z-index: 9999 !important;
}
.van-dialog {
  z-index: 10000 !important;
} */
</style>
